export enum CreditCardBrandsEnum {
  Visa = 'VISA',
  MasterCard = 'MASTERCARD',
  AmericanExpress = 'AMERICAN_EXPRESS',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
}
